import { 
  Impact, 
  ImpactFormData
} from '../types/impact';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const impactsApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getImpacts: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getImpacts,
        method: 'get',
      }),
      providesTags: ['Impacts'],
    }),
    
    getImpactById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.getImpacts}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Impacts', id }],
    }),

    addImpact: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addImpact,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Impacts"] : []),
    }),

    updateImpact: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateImpact}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Impacts"] : []),
    }),

    deleteImpact: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteImpact}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Impacts'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetImpactsQuery,
  useGetImpactByIdQuery,
  useAddImpactMutation,
  useUpdateImpactMutation,
  useDeleteImpactMutation,
} = impactsApi;

